<template>
  <div>
    <div class="flex-vertical photo-container">
      <input
        v-if="shownImage"
        type="image"
        :src="getPhotoWithBase64(shownImage)"
        :alt="label"
        class="fill-space"
        @click="openImageDialog"
      />
      <div class="flex-vertical photo-options" v-if="shownImage">
        <MenuButton
          class="photo-options-button"
          @click="hoverMenu = !hoverMenu"
        />
        <photo-menu
          v-show="hoverMenu"
          @updateImage="onFileChange"
          @removeImage="removeImage"
        />
      </div>

      <div
        v-else
        class="input-photo fill-space"
        :class="{ disabled: disabled }"
        :style="{ 'background-image': `url(${photoIcon})` }"
        @change="onFileChange"
      >
        <input
          class="photo-input fill-space"
          type="file"
          accept="image/*"
          title
          :disabled="disabled"
        />
      </div>
    </div>
    <photo-opened
      v-if="imageDialog"
      :imageData="imageData"
      :image="value.image"
      :thumb="value.image_thumb"
      :description="value.description"
      :uuid="value.uuid"
      :disabled="disabled"
      @removeImage="removeImage"
      @close="closeImageDialog"
      @updateDescription="updateDescription"
    />

    <photo-upload-error
      :toggleDialog="uploadErrorDialog"
      :specificErrorMessage="$t(specificErrorMessage)"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";
import photoIcon from "@/assets/home/photosForm/photo.png";
import MenuButton from "@/assets/home/photosForm/more_menu.svg";
import PhotoMenu from "@/components/Home/Forms/_SpecialTabs/Photos/PhotoMenu";
import PhotoOpened from "@/components/Home/Forms/_SpecialTabs/Photos/PhotoOpened";
import PhotoUploadError from "@/components/Home/Forms/_SpecialTabs/Photos/PhotoUploadError";
export default {
  name: "inputTypePhoto",

  components: { MenuButton, PhotoMenu, PhotoOpened, PhotoUploadError },

  mixins: [inputTypeMixin],

  props: {
    label: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      hoverPhoto: false,
      hoverMenu: false,
      uploadErrorDialog: false,
      specificErrorMessage: "",
      imageDialog: false,
      imageData: null,
      previousImage: false,
      shownImage: null,
      photoIcon
    };
  },

  computed: {
    photoUploaded() {
      return this.value && this.value.image_thumb !== "";
    }
  },

  mounted() {
    if (this.photoUploaded) {
      this.previousImage = true;
    }
    if (this.value) {
      this.shownImage = this.value.image
        ? this.value.image
        : this.value.image_thumb;
    }
    this.imageData = {
      label: this.label,
      varName: this.varName
    };
  },

  methods: {
    onFileChange(e) {
      this.hoverMenu = false;
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      if (file.type.includes("image")) {
        let reader = new FileReader();

        reader.onload = e => {
          let newImage = {
            name: this.varName,
            photo: e.target.result
          };
          this.$emit("change", newImage);
          this.shownImage = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.specificErrorMessage = "ChooseImageFile";
        this.uploadErrorDialog = true;
      }
    },

    removeImage() {
      this.hoverMenu = false;
      this.shownImage = "";
      this.$emit("removePhoto", this.previousImage ? this.value : this.varName);
    },

    closeErrorDialog() {
      this.uploadErrorDialog = false;
      this.specificErrorMessage = "";
    },

    openImageDialog() {
      this.hoverMenu = false;
      this.imageDialog = true;
    },

    closeImageDialog() {
      this.imageDialog = false;
    },

    getPhotoWithBase64(image) {
      if (
        image.includes("data:image/jpeg;base64,") ||
        image.includes("data:image/png;base64,")
      ) {
        return image;
      } else return "data:image/jpeg;base64," + image;
    },

    updateDescription(description) {
      this.$emit("change", {
        name: this.varName,
        description: description
      });
    }
  }
};
</script>

<style scoped>
.input-photo {
  border: 1px solid var(--secondary-lighter);
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-color: #ffffff;
}
.fill-space {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.photo-container {
  width: 100%;
  height: 100px;
  overflow: hidden;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypePhoto.vue